import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { StihlLogDTO } from '../models/stihl-log-dto';


@Injectable({
  providedIn: 'root'
})

export class TrackingService {

  private pathAPI = environment.urlAPI;
  private controller = "Tracking/";

  constructor(private http: HttpClient) { }



  public trackElement(id: string, type: number): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + 'TrackElement/' + id + '/' + type, null);
  }

  public trackUser(data: StihlLogDTO): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + 'TrackUser/', data);
  }

  public trackVideo(id: any): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + 'TrackVideo/' + id, null);
  }

  public trackDocument(id: string, idLogType: number): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + 'TrackDocument/' + id + '/' + idLogType, null);
  }

  public trackAccessCampaign(idCampaign: string): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + 'TrackAccessCampaign/' + idCampaign, null);
  }

  public trackCampaignPub(id: string, idLogType): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'TrackCampaignPub/' + id + "/" + idLogType);
  }


}
